var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as categoryFactory from '../../../classes/definitions/category/category';
import { DropdownOption } from '../../../classes/definitions/formItem/ElementConfig';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import Config from '../../../config/config';
import categorySchema from '../../../schemas/categorySchema';
import Input from '../../UI/Input/Input';
var CategoryForm = /** @class */ (function (_super) {
    __extends(CategoryForm, _super);
    function CategoryForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.imageChanged = false; // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(categorySchema),
            formIsValid: false,
            discardPopupVisble: false,
            parentSuggestions: [],
        };
        _this.getCategory = function (id) {
            _this.api
                .getCategory(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на категорията';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var category = categoryFactory.createCategory(_.get(data, 'attributes', {}));
            var imageUrl = category.ImageUrl ? Config.cdnDomain + category.ImageUrl : null;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'bg_name.value', category.BgName);
            _.set(updatedFormConfig, 'bg_name.touched', true);
            _.set(updatedFormConfig, 'bg_name.valid', true);
            _.set(updatedFormConfig, 'en_name.value', category.EnName);
            _.set(updatedFormConfig, 'en_name.touched', true);
            _.set(updatedFormConfig, 'en_name.valid', true);
            _.set(updatedFormConfig, 'bg_description.value', category.BgDescription);
            _.set(updatedFormConfig, 'bg_description.touched', true);
            _.set(updatedFormConfig, 'bg_description.valid', true);
            _.set(updatedFormConfig, 'en_description.value', category.EnDescription);
            _.set(updatedFormConfig, 'en_description.touched', true);
            _.set(updatedFormConfig, 'en_description.valid', true);
            _.set(updatedFormConfig, 'position.value', category.Position ? category.Position : null);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _.set(updatedFormConfig, 'slug.value', category.Slug);
            _.set(updatedFormConfig, 'slug.touched', true);
            _.set(updatedFormConfig, 'slug.valid', true);
            _.set(updatedFormConfig, 'home_visible.value', category.HomeVisible);
            _.set(updatedFormConfig, 'home_visible.touched', true);
            _.set(updatedFormConfig, 'home_visible.valid', true);
            _.set(updatedFormConfig, 'brand_hidden.value', category.BrandHidden);
            _.set(updatedFormConfig, 'brand_hidden.touched', true);
            _.set(updatedFormConfig, 'brand_hidden.valid', true);
            _.set(updatedFormConfig, 'header_hidden.value', category.HeaderHidden);
            _.set(updatedFormConfig, 'header_hidden.touched', true);
            _.set(updatedFormConfig, 'header_hidden.valid', true);
            _.set(updatedFormConfig, 'meta_title.value', category.MetaTitle);
            _.set(updatedFormConfig, 'meta_title.touched', true);
            _.set(updatedFormConfig, 'meta_title.valid', true);
            _.set(updatedFormConfig, 'meta_description.value', category.MetaDescription);
            _.set(updatedFormConfig, 'meta_description.touched', true);
            _.set(updatedFormConfig, 'meta_description.valid', true);
            _.set(updatedFormConfig, 'image.value', imageUrl);
            _.set(updatedFormConfig, 'image.touched', true);
            _.set(updatedFormConfig, 'image.valid', true);
            // removing the field for parent id on edit
            delete updatedFormConfig.parent_id;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            // The blur methods resets teh autocomplete for some reason
            if (id === 'parent_id' && eventType === 'onBlur') {
                return;
            }
            if (id !== 'home_visible' && id !== 'brand_hidden' && id !== 'header_hidden') {
                updatedFormElement.value = id !== 'parent_id' ? event.target.value : event.value;
            }
            else {
                updatedFormElement.value = event.checked;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            if (id === 'image' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var parentId = _.get(formData, 'parent_id.value.value', null);
            var submittedCategory = new FormData();
            var image = _.get(formData, 'image.value', null);
            submittedCategory.append('category[bg_name]', _.get(formData, 'bg_name.value', ''));
            submittedCategory.append('category[en_name]', _.get(formData, 'en_name.value', ''));
            submittedCategory.append('category[bg_description]', _.get(formData, 'bg_description.value', ''));
            submittedCategory.append('category[en_description]', _.get(formData, 'en_description.value', ''));
            submittedCategory.append('category[position]', _.get(formData, 'position.value', ''));
            submittedCategory.append('category[slug]', _.get(formData, 'slug.value', ''));
            submittedCategory.append('category[home_visible]', _.get(formData, 'home_visible.value', false));
            submittedCategory.append('category[brand_hidden]', _.get(formData, 'brand_hidden.value', false));
            submittedCategory.append('category[header_hidden]', _.get(formData, 'header_hidden.value', false));
            submittedCategory.append('category[meta_description]', _.get(formData, 'meta_description.value', ''));
            submittedCategory.append('category[meta_title]', _.get(formData, 'meta_title.value', ''));
            if (parentId) {
                submittedCategory.append('category[parent_id]', _.get(formData, 'parent_id.value.value', null));
            }
            // Additional requirements from the backend
            if (_this.editId && _this.imageChanged && !image) {
                submittedCategory.append('category[remove_image]', '1');
            }
            else if (_this.editId && _this.imageChanged && image) {
                submittedCategory.append('category[image]', image);
            }
            else if (!_this.editId.length && _this.imageChanged && image) {
                submittedCategory.append('category[image]', image);
            }
            var actionMethod = _this.editId === '-1' ? _this.api.createCategory : _this.api.updateCategory;
            actionMethod(submittedCategory, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toCategoriesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на категория';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toCategoriesPage = function () {
            _this.props.history.push(AppRoutes.categories.path);
        };
        // searches through the api for category that has to be assigned as parent
        _this.getSuggestions = function (event) {
            _this.api
                .searchCategory(event.query)
                .then(function (response) {
                _this.mapSuggestionsToField(_.get(response, 'data.data', []));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при търсене на категория';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.mapSuggestionsToField = function (rawData) {
            var controlSuggestions = rawData.map(function (item, key) {
                return new DropdownOption({
                    label: _.get(item, 'attributes.bg_name', ''),
                    value: _.get(item, 'id', '-1'),
                });
            });
            _this.setState({ parentSuggestions: controlSuggestions });
        };
        return _this;
    }
    CategoryForm.prototype.componentDidMount = function () {
        var _a;
        this.editId = _.get(this.props, 'match.params.categoryId', '-1');
        if (this.editId !== '-1') {
            (_a = this.props) === null || _a === void 0 ? void 0 : _a.isEdit(true);
            this.getCategory(this.editId);
        }
    };
    CategoryForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, parentSuggestions = _a.parentSuggestions;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); }, completeMethod: _this.getSuggestions, suggestions: parentSuggestions }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toCategoriesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return CategoryForm;
}(React.Component));
// @ts-ignore
export default withRouter(CategoryForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Categories/CategoryForm/CategoryForm.tsx
// module id = 332
// module chunks = 0